 const swiperCountryTag = new Swiper('.country__tag__slider', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    watchSlidesProgress: true,
    pagination: {
      el: ".country__tag__slider-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".country__tag__slider-next",
      prevEl: ".country__tag__slider-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false,
    },
});